import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/layout/navbar'
import { Footer } from '@/components/layout/footer'

interface SiteLayoutProps extends LayoutProps {
    /** Hide the footer on minimal pages (404 / password). */
    showFooter?: boolean
}

export const Layout: FC<SiteLayoutProps> = ({ children, showFooter = true }): ReactNode => {
    return (
        <div className='page-wrapper'>
            <Navbar />

            <main>{children}</main>

            {showFooter && <Footer />}
        </div>
    )
}
